import React from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import { useTranslation } from "react-i18next";
import { makeSepTableData } from "../Table/makeData";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import "./SepTable.scss";
import "../../assets/scss/variables.scss";
import {NamList} from "../../utils/helpers/table";

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const { t } = useTranslation("common");
  const colsWithSort = [
    t("depositsInnerTable.gemel"),
    t("depositsInnerTable.depositDate"),
    t("depositsInnerTable.monthSalary")
  ];
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
      disableSortRemove: true,
    },
    useSortBy,
    usePagination
  );
  // Render the UI for your table
  return (
    <div className="septable-wrapper">
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(
                (column) =>
                  !column.hideHeader && (
                    <th
                      {...column.getHeaderProps(
                        colsWithSort.includes(column.Header) &&                        
                          column.getSortByToggleProps({ title:  t("depositsInnerTable.sortByFieldName") })
                      )}
                    >
                      {column.render("Header")}
                      <span>
                        {colsWithSort.includes(column.Header) &&
                          setColIsSorted(column)}
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <ArrowDropDownIcon />
                          ) : (
                            <ArrowDropUpIcon />
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </th>
                  )
              )}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {pageOptions.length !== 1  ?
      <div className="pagination">
        <button
          onClick={() => nextPage()}
          disabled={!canNextPage}
          style={{ border: 0, backgroundColor: "transparent" }}
          aria-label="Next page"
        >
          <ArrowForwardIosOutlinedIcon
            sx={{
              marginLeft: "10px",
              cursor: "pointer",
              "&:hover": {
                color: "$Logo-L400",
              },
            }}
          />
        </button>
            {/*{t("general.page")}{" "} {pageIndex + 1} {t("general.from")} {pageOptions.length} */}
            <li>{NamList(pageIndex , pageOptions , gotoPage)}</li>  
        <button
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
          style={{ border: 0, backgroundColor: "transparent" }}
          aria-label="Previous page"
        >
          <ArrowBackIosOutlinedIcon
            sx={{
              marginLeft: "10px",
              cursor: "pointer",
              "&:hover": {
                color: "$Logo-L400",
              },
            }}
          />
        </button>
      </div>
      : null}
    </div>
  );
}
function setColIsSorted(column) {
  column.isSorted = true;
}
function SepTable({ tableData }) {
  const { t } = useTranslation("common");
  const columns = React.useMemo(
    () => [
      {
        Header: "1",
        hideHeader: true,
        columns: [
          {
            Header:t("depositsInnerTable.gemel"),
            accessor: "kopatGemel",
            sortDescFirst: true,
          },
          {
            Header: t("depositsInnerTable.employerName"),
            accessor: "employerName",
            sortDescFirst: true,
          },
          {
            Header: t("depositsInnerTable.depositDate"),
            accessor: "depositDate",
            disableFilters: true,
            sortDescFirst: true,
            sortType: (a, b) => {
              if (
                new Date(a.values.depositDate).valueOf() >
                new Date(b.values.depositDate).valueOf()
              )
                return 1;
              if (
                new Date(b.values.depositDate).valueOf() >
                new Date(a.values.depositDate).valueOf()
              )
                return -1;
              return 0;
            },
          },
          {
            Header: t("depositsInnerTable.monthSalary"),
            accessor: "salaryMonth",
            disableFilters: true,
            sortDescFirst: true,
            sortType: (a, b) => {
              if (
                new Date(`01/${a.values.depositDate}`).valueOf() >
                new Date(`01/${b.values.depositDate}`).valueOf()
              )
                return 1;
              if (
                new Date(`01/${b.values.depositDate}`).valueOf() >
                new Date(`01/${a.values.depositDate}`).valueOf()
              )
                return -1;
              return 0;
            },
          },
          {
            Header: t("deposits.depositSum") + " ₪",
            accessor: "sum",
          },
          {
            Header: t("depositsInnerTable.employeeBenefits") + " ₪",
            accessor: "employeeAwards",
          },
          {
            Header: t("depositsInnerTable.employerBenefits") + " ₪",
            accessor: "employerAwards",
          },
          {
            Header: t("depositsInnerTable.compensation") + " ₪",
            accessor: "awards",
          },
          {
            Header: t("depositsInnerTable.depositType"),
            accessor: "depositType",
          },
        ],
      },
    ],
    []
  );
  const data = React.useMemo(() => makeSepTableData(tableData), [tableData]);
  return <Table columns={columns} data={data} />;
}
export default SepTable;